import {
  borderLinesToCss,
  borderRadiusToCss,
  borderToSx,
  normalizeBorder,
} from "./borderUtils";

export const hasBorderRadius = (border) => {
  const normalized = normalizeBorder(border);
  if (normalized.advanced) {
    return [normalized.top, normalized.right, normalized.bottom, normalized.left].some(
      (side) => (side.radius || 0) > 0
    );
  }
  return (normalized.radius || 0) > 0;
};

/** Inline CSS for wcp-cell-inner (preview + final HTML). */
export const buildCellInnerStyleCss = (props) => {
  const lines = borderLinesToCss(props?.border);
  const radius = borderRadiusToCss(props?.border);
  const parts = [
    "box-sizing: border-box;",
    "width: 100%;",
    lines ? `${lines};` : "",
    radius ? `${radius};` : "",
    props?.backgroundColor ? `background-color: ${props.backgroundColor};` : "",
    props?.padding ? `padding: ${props.padding};` : "",
  ];

  if (hasBorderRadius(props?.border)) {
    parts.push("overflow: hidden;");
  }

  return parts.filter(Boolean).join(" ").replace(/\s+/g, " ").trim();
};

/** React inline style for the inner cell box in the canvas. */
export const buildCellInnerCanvasStyle = (props) => {
  const style = {
    ...borderToSx(props?.border),
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    width: "100%",
    flex: "1 1 auto",
    minHeight: 0,
    margin: 0,
  };

  if (props?.padding) {
    style.padding = props.padding;
  }
  if (props?.backgroundColor) {
    style.backgroundColor = props.backgroundColor;
  }
  if (hasBorderRadius(props?.border)) {
    style.overflow = "hidden";
  }

  return style;
};

export const cellGapPaddingPx = (cellGap) => {
  const gap = Number.parseInt(String(cellGap ?? 0), 10);
  if (!Number.isFinite(gap) || gap <= 0) {
    return 0;
  }
  return gap / 2;
};

export const cellGapPaddingCss = (cellGap) => {
  const padding = cellGapPaddingPx(cellGap);
  return padding > 0 ? `padding: ${padding}px;` : "";
};
 